import Vue from "vue";
import { vueBaberrage } from "vue-baberrage";

[vueBaberrage].forEach((item) => Vue.use(item));
